/* Bildbläddring på produktkort (2026-10-13). Delegerad: fungerar även för kort som läggs till senare. */
(function () {
  if (window.__haBladdra) return;
  window.__haBladdra = true;
  function index(hb) {
    var s = hb.querySelector('.hb__spar');
    return Math.round(s.scrollLeft / Math.max(1, s.clientWidth));
  }
  function uppdatera(hb) {
    var s = hb.querySelector('.hb__spar');
    if (!s) return;
    var n = s.children.length, i = Math.min(n - 1, Math.max(0, index(hb)));
    var p = hb.querySelectorAll('.hb__prickar i');
    for (var k = 0; k < p.length; k++) p[k].classList.toggle('is-pa', k === i);
    var v = hb.querySelector('.hb__pil--v'), h = hb.querySelector('.hb__pil--h');
    if (v) v.classList.toggle('is-av', i === 0);
    if (h) h.classList.toggle('is-av', i === n - 1);
  }
  function init(rot) {
    var l = (rot || document).querySelectorAll('[data-hb]:not([data-hb-klar])');
    for (var k = 0; k < l.length; k++) {
      var hb = l[k]; hb.setAttribute('data-hb-klar', '');
      uppdatera(hb);
      hb.querySelector('.hb__spar').addEventListener('scroll', (function (h) { return function () { uppdatera(h); }; })(hb), { passive: true });
    }
  }
  document.addEventListener('click', function (e) {
    var pil = e.target.closest && e.target.closest('[data-hb-pil]');
    if (pil) {
      e.preventDefault(); e.stopPropagation();
      var hb = pil.closest('[data-hb]'), s = hb.querySelector('.hb__spar');
      var d = parseInt(pil.getAttribute('data-hb-pil'), 10);
      var n = s.children.length, i = Math.min(n - 1, Math.max(0, index(hb) + d));
      s.scrollTo({ left: i * s.clientWidth, behavior: 'smooth' });
      return;
    }
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  new MutationObserver(function () { init(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
